export enum SpecialityType {
    UNKNOWN,
    PHYSIOTHERAPIST,
    CHIROPRACTOR,
    CHIROPODIST,
    DOCTOR,
    OSTEOPATH,
    REHABILITATION_DOCTOR,
    SPORTS_MEDICINE_DOCTOR,
    ORTHOPEDIC_SURGEON,
    PODOLOGIST,
    FITNESS_TRAINER,
    SPORTS_COACH,
    STUDENT,
    OTHER,
    PEDIATRICS ,
    WOMEN_HEALTH ,
    ONCOLOGY ,
    NEUROLOGY ,
    SPORTS ,
    GERIATRICS ,
    CLINICAL_ELECTROPHYSIOLOGY ,
    ORTHOPEDICS ,
    CARDIOVASCULAR_PULMONARY ,
}

export class SpecialityTypes {
    public static parse(speciality: string): SpecialityType {
        return SpecialityType[speciality as keyof typeof SpecialityType];
    }

    public static format(specialityType?: SpecialityType): string {
        let formatted;
        switch (specialityType) {
            case SpecialityType.PHYSIOTHERAPIST:
                formatted = 'Physiotherapist';
                break;
            case SpecialityType.CHIROPRACTOR:
                formatted = 'Chiropractor';
                break;
            case SpecialityType.CHIROPODIST:
                formatted = 'Chiropodist';
                break;
            case SpecialityType.DOCTOR:
                formatted = 'Doctor';
                break;
            case SpecialityType.OSTEOPATH:
                formatted = 'Osteopath';
                break;
            case SpecialityType.REHABILITATION_DOCTOR:
                formatted = 'Rehabilitation Doctor';
                break;
            case SpecialityType.SPORTS_MEDICINE_DOCTOR:
                formatted = 'Sports Medicine Doctor';
                break;
            case SpecialityType.ORTHOPEDIC_SURGEON:
                formatted = 'Orthopedic Surgeon';
                break;
            case SpecialityType.PODOLOGIST:
                formatted = 'Podologist';
                break;
            case SpecialityType.FITNESS_TRAINER:
                formatted = 'Fitness Trainer';
                break;
            case SpecialityType.SPORTS_COACH:
                formatted = 'Sports Coach';
                break;
            case SpecialityType.STUDENT:
                formatted = 'Student';
                break;
            case SpecialityType.OTHER:
                formatted = 'Other';
                break;
            case SpecialityType.PEDIATRICS:
                formatted = 'Pediatrics';
                break;
            case SpecialityType.WOMEN_HEALTH:
                formatted = 'Women health';
                break;
            case SpecialityType.ONCOLOGY:
                formatted = 'Oncology';
                break;
            case SpecialityType.NEUROLOGY:
                formatted = 'Neurology';
                break;
            case SpecialityType.SPORTS:
                formatted = 'Sports';
                break;
            case SpecialityType.GERIATRICS:
                formatted = 'Geriatrics';
                break;
            case SpecialityType.CLINICAL_ELECTROPHYSIOLOGY:
                formatted = 'Clinical Electrophysiology';
                break;
            case SpecialityType.ORTHOPEDICS:
                formatted = 'Orthopedics';
                break;
            case SpecialityType.CARDIOVASCULAR_PULMONARY:
                formatted = 'Cardiovascular Pulmonary';
                break;
            default:
                formatted = '';
                break;
        }
        return formatted;
    }
}
